
export default {
  props: {
    value: {
      type: Object,
      default: () => {
        return {
          action: '',
          fileUploader: {
            label:
              'Click or drop files here to upload (.pdf, .docx, .txt, .csv). There is a 5 file, 25 MB total-file limit to attachments',
            maxFileSizeValidationMessage: 'Max file size: 5MB',
            generalValidationErrorMessage: 'You cannot upload any more files.',
            unsupportedMediaType: 'You can upload only .pdf, .docx, .txt, .csv',
            removeItemLabel: 'Remove'
          },
        }
      }
    }
  },
  data() {
    return {
      errorMessage: {},
      acceptedFiles: [],
      failedFiles: [],
      dropzoneCallback: () => {},
      dropzoneOptions: {
        url: '/users/communication',
        thumbnailWidth: 150,
        maxFilesize: 5,
        maxFiles: 5,
        maxThumbnailFilesize: 3,
        autoProcessQueue: false,
        disablePreviews: true,
        previewTemplate: this.template(),
        acceptedFiles: '.pdf, .docx, .txt, .csv'
      },
      dropZoneKey: 0,
    }
  },
  methods: {
    template() {
      return `<div class="dz-preview dz-file-preview">
            <div class="dz-image">
              <div data-dz-thumbnail-bg style="height:100%"></div>
            </div>
            <div class="dz-details">
              <div class="dz-size"><span data-dz-size></span></div>
              <div class="dz-filename"><span data-dz-name></span></div>
            </div>
            <div class="dz-error-message"><span data-dz-errormessage>${this.value.fileUploader.validationMessage || this.value.fileUploader.generalValidationErrorMessage}</span></div>
            <div class="dz-success-mark"><i class="fa fa-check"></i></div>
            <div class="dz-error-mark"><i class="fa fa-times"></i></div>
            <a class="dz-remove" href="javascript:undefined;" data-dz-remove="">${this.value.fileUploader.removeItemLabel}</a>
          </div>`
    },
    thumbnail: function(file, dataUrl) {
      let j, len, ref, thumbnailElement
      if (file.previewElement) {
        file.previewElement.classList.remove('dz-file-preview')
        ref = file.previewElement.querySelectorAll('[data-dz-thumbnail-bg]')
        for (j = 0, len = ref.length; j < len; j++) {
          thumbnailElement = ref[j]
          thumbnailElement.alt = file.name
          thumbnailElement.style.backgroundImage = 'url("' + dataUrl + '")'
        }
        return setTimeout(
          (function(_this) {
            return function() {
              return file.previewElement.classList.add('dz-image-preview')
            }
          })(this),
          1
        )
      }
    },
    evaluateUploadedFiles(previews, max) {
      let amount = 0
      const thumbnails = document.getElementsByClassName('dz-file-preview')

      previews.forEach((preview, i) => {
        amount = amount + preview.size
        if(thumbnails[i]){
          if (amount > max) {
            thumbnails[i].classList.replace('dz-success', 'dz-error')
            thumbnails[i].classList.add('dz-error')
          } else if (preview.accepted === false) {
            thumbnails[i].classList.replace('dz-success', 'dz-error')
            thumbnails[i].classList.add('dz-error')
          } else {
            thumbnails[i].classList.replace('dz-error', 'dz-success')
            thumbnails[i].classList.add('dz-success')
          }
        }
      })
    },
    async checkFiles() {
      const maxFiles = this.dropzoneOptions.maxFiles
      this.acceptedFiles = await this.$refs.myVueDropzone.getAcceptedFiles()
      this.failedFiles = await this.$refs.myVueDropzone.getRejectedFiles()

      // if (this.failedFiles && this.failedFiles.length > 0 && this.acceptedFiles.length < maxFiles) {
        // this.$refs.myVueDropzone.removeFile(failedFiles[0])
        // this.$refs.myVueDropzone.addFile(failedFiles[0])
      // }

      const allFiles = this.acceptedFiles.concat(this.failedFiles)
      const totalSize = allFiles.reduce((a, b) => a + (b.size || 0), 0)
      const max = 25000000 // 25mb

      const previews = document.getElementsByClassName('dz-file-preview')

      this.errorMessage = {
        defaultMessage: ''
      }

      // Evaluate all files and add the "error" or "success" flag to each
      this.evaluateUploadedFiles(allFiles, max)

      this.dropzoneCallback()

      if (totalSize > max) {
        // this.maxReached = true
        this.errorMessage.defaultMessage = this.value.fileUploader.maxFileSizeValidationMessage
        previews[previews.length - 1].classList.replace(
          'dz-success',
          'dz-error'
        )
      } else if (this.failedFiles.length) {
        // this.maxReached = true
        this.errorMessage.defaultMessage = this.value.fileUploader.generalValidationErrorMessage
        previews[previews.length - 1].classList.replace(
          'dz-success',
          'dz-error'
        )
      } else {
        this.errorMessage = undefined
        // this.maxReached = false
        previews[previews.length - 1].classList.replace(
          'dz-error',
          'dz-success'
        )
      }
    },
    manuallyOpenDropzone() {
      this.$el.querySelector('#dropzone').click()
    },
  },

}
